import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "./auth";
import { getCart, addToCart as apiAdd, removeCartItem as apiRemove } from "./commerce";

const Ctx = createContext(null);

export function CartProvider({ children }) {
  const { isAuthed } = useAuth();
  const [items, setItems] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);

  const refresh = useCallback(async () => {
    if (!isAuthed) { setItems([]); setGrandTotal(0); return; }
    try { const d = await getCart(); setItems(d.items || []); setGrandTotal(d.grand_total || 0); }
    catch { setItems([]); setGrandTotal(0); }
  }, [isAuthed]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = useCallback(async (payload) => { const r = await apiAdd(payload); await refresh(); return r; }, [refresh]);
  const remove = useCallback(async (id) => { await apiRemove(id); await refresh(); }, [refresh]);

  const value = useMemo(() => ({ items, count: items.length, grandTotal, add, remove, refresh }),
    [items, grandTotal, add, remove, refresh]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useCart() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useCart must be used within CartProvider");
  return v;
}
